
let callbacks = [];
let running = false;

// fired on resize event
function resize() {
    if (!running) {
        running = true;
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(runCallbacks);
        } else {
            setTimeout(runCallbacks, 66);
        }
    }
}

function addResizeEventListener() {
    window.addEventListener('resize', resize, false);
}

// run the actual callbacks
function runCallbacks() {
    let event = document.createEvent('Event');
    event.initEvent('TaskboardWindowResize', true, true);
    window.dispatchEvent(event);

    callbacks.forEach(function(callback) {
        callback();
    });
    running = false;
}

// adds callback to loop
function addOnResizeCallback(callback) {
    if (callback && typeof callback === "function") {
        callbacks.push(callback);
    }
}

export default {
    addResizeEventListener,
    addOnResizeCallback
};



// WEBPACK FOOTER //
// ./src/utils/onResize.js